import { apiClient as api } from '@plerionhq/design-system';
import { useQuery } from '@tanstack/react-query';
import { useGrantsScope } from './use-grants-scope';

export type GrantsStats = {
  total: number;
  external: number;
  untrustedExternal: number;
  crossAccount: number;
};

const STATS_PATH = '/api/core/access/grants/stats';

// Aggregate grant counts for the resource-access-grants KPI strip. Per-principal
// table data (AWS principals, suggested principals) lives in its own hooks
// (use-aws-principals, use-suggested-principals) so this stays a thin KPI query.
export function useGrantsStats() {
  const scope = useGrantsScope();
  return useQuery<GrantsStats>({
    queryKey: ['access-grants-stats', scope],
    queryFn: async () => {
      // Backend wraps as { data: GrantsStats } via jsonStatus, and axios puts the
      // JSON body on res.data — so the payload is res.data.data.
      const res = await api.get<{ data: GrantsStats }>(STATS_PATH, {
        params: scope,
      });
      return res.data.data;
    },
    staleTime: 60_000,
  });
}
